module.exports = __webpack_public_path__ + "vfn-assets/img/face-id-scanv.8e698f39.svg";